import {
  HStack,
  PopoverTrigger,
  Popover,
  VStack,
  Icon,
  PopoverContent,
  Badge,
  Box,
  Text,
  IconButton,
  Button,
  PopoverBody,
  PopoverHeader,
  NumberInput,
  NumberInputField,
  OrderedList,
  ListItem,
  Link,
  Select,
  Tooltip,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Input,
} from "@chakra-ui/react";
import { ChevronDownIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import { MenuBook } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  BiCart,
  BiChevronDown,
  BiChevronUp,
  BiDownload,
  BiInfinite,
  BiShow,
} from "react-icons/bi";
import {
  FiAlertTriangle,
  FiArrowDown,
  FiArrowRight,
  FiArrowUp,
  FiUser,
} from "react-icons/fi";
import {
  formatDate,
  formatTime,
  findLatestETAWithGivenTime,
  formatInDateMonthYearUTC,
  formatDateTime,
} from "../../../utils/dateResolvers";
import { formatCurrency } from "../../../utils/formatCurrency";
import { downloadInvoiceForOrder, getEnquiryStatus } from "../orderUtils";
import {
  BillingEntity,
  CPTSlabForManualOption,
  epochPlatformEtaSeconds,
  getSupplierStateColor,
  OrderStatus,
  PaymentType,
  Roles,
} from "../enums";
import GarrazCopyText from "./GaraazCopyText";
import GaraazGeneralPopover from "./GaraazGeneralPopover";
import GaraazPopOverContainerStack from "./GaraazPopOverContainerStack";
import { useOrdersStore } from "../store/useOrdersStore";
import {
  AllocatedTo,
  finalOrcaStates,
  startOrcaStates,
} from "./GaraazOrderComponent";
import { useGetOrderMediaConfig } from "../../PlaceOrderTest/queryHooks";
import {
  useGetAllSuppliers,
  useGetCustomerAllSubscriptions,
  useGetGrazeons,
  useGetInsuranceUsers,
} from "../queryHooks";
import {
  useCallback,
  useEffect,
  useMemo,
  useState,
  type MouseEvent,
} from "react";
import services from "../services";
import GaraazCountDownClockV2 from "./GaraazCountDownClockV2";
import GaraazCptSlotLabel from "./GaraazCptSlotLabel";
import { pickOrderEtaMinGaraazSlot } from "../utils/orderEtaGaraazSlot";
import { GiReturnArrow } from "react-icons/gi";
import { AiOutlineStop } from "react-icons/ai";
import { removeUnderScoreWithUpperCase } from "../../../utils/removeUnderscore";
import useNotification from "../../../utils/useNotification";
import {
  FaTruckLoading,
  FaWalking,
  FaTruck,
  FaCarSide,
  FaSyncAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { FcShipped } from "react-icons/fc";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { BiDollarCircle } from "react-icons/bi";
import paths from "../../../utils/paths";
import { NavLink } from "react-router-dom";
import { EngagementMode } from "../enums";
import GaraazGeneralPopoverV2 from "./GaraazGeneralPopverV2";
import { formatSupplierAssociationsForDisplay } from "../../../utils/supplierAssociationUtils";
import ContactPersonsNestedPopover from "./ContactPersonsNestedPopover";
import { BadgeWithTooltip } from "@svan-garaaz/reactsharedlib";
import { DeliveryModes } from "../enums";
import { useUserDetailsContext } from "../../../context/userDetailsContext";
import ChatButton from "../../Chat/components/ChatButton";
import ChooseCarModel from "./ChooseCarModel";
import {
  formatMobileNumber,
  getNationalMobileForCopy,
} from "../../../utils/util";
import {
  getCustomerMissionControlUrl,
  getSupplierMissionControlUrl,
  openMissionControlUrl,
} from "../../../utils/missionControlLinks";
import { ChatType } from "../../../types/chatTypes";
import { OrderTypes } from "../enums";
import {
  useOrderLabel,
  GetOrderLabels,
} from "./GaraazOrderCard/OrderLabelContext";
import dayjs from "dayjs";
import PaymentRouteBadge from "./PaymentRouteBadge";
import {
  buildSupplierWebOrderEditUrl,
  getSupplierWebAppBaseUrl,
} from "../../../utils/supplierWebOrderDeepLink";
import { hasGaraazInvoiceUploaded } from "../orderUtils";

const ALLOCATION_ACTION_ICONS: Record<
  string,
  { icon: typeof FiArrowDown; color: string; label: string }
> = {
  STOCK_IN: { icon: FiArrowDown, color: "#2563EB", label: "Stock In" },
  STOCK_OUT: { icon: FiArrowUp, color: "#EA580C", label: "Stock Out" },
  PROCESS: { icon: FiArrowRight, color: "#6B7280", label: "Process" },
};

type GaraazOrderComponentHeaderProps = {
  expandBody: () => void;
  orderStatus: any;
  isBodyVisible: boolean;
  orderData: any;
  etaMissed: boolean;
  setEtaMissed: React.Dispatch<React.SetStateAction<boolean>>;
  activesupplierOrderStatus: AllocatedTo;
  findBrandName?: (brandId: string) => any;
  transactionType: any;
  getSupplierBusinessName: (supplierId: string) => any;
  getSupplierParentId: (supplierId: string) => string;
  isCustomerOrderFreezed: boolean;
  isEnquiryLocked?: boolean;
  getSupplierBranchName: (supplierId: any, branchId: any) => any;
  getSupplierNumber: (supplierId: string, branchId?: string) => string;
  isEstimateRequired: boolean;
  isUrgent: boolean;
  partType: string[];
  refetchAllOrders: () => void;
  onOpenCptUpdate?: () => void;
};

interface DeliveryModeBadgeProps {
  mode: DeliveryModes.DOOR_DELIVERY | DeliveryModes.SELF_PICKUP;
  className?: any;
}

export const DeliveryModeBadge: React.FC<DeliveryModeBadgeProps> = ({
  mode,
  className,
}) => {
  className = {
    fontSize: "x-small",
    bg: "#3B84F6",
    color: "white",
    iconFontSize: "small",
  };

  switch (mode) {
    case DeliveryModes.DOOR_DELIVERY:
      return (
        <BadgeWithTooltip
          icon={<FaTruck fontSize={className.iconFontSize} />}
          label="Door Delivery"
          className={className}
        />
      );

    case DeliveryModes.SELF_PICKUP:
      return (
        <BadgeWithTooltip
          icon={<FaWalking fontSize={className.iconFontSize} />}
          label="Self Pickup"
          className={className}
        />
      );

    default:
      return <BadgeWithTooltip icon={null} label="-" className={className} />;
  }
};

const isEnquiryEtaMissed = (
  orderEta:
    | Array<{ etaGivenTime: string; eta: string; reason?: string }>
    | undefined
    | null,
  estimateSharedAt: string | undefined,
): boolean => {
  if (!orderEta || orderEta.length !== 1) {
    return false;
  }

  const etaTime = dayjs(orderEta[0].eta);
  if (!estimateSharedAt) {
    return true;
  }

  const sharedAtTime = dayjs(estimateSharedAt);
  return sharedAtTime.isAfter(etaTime);
};

type InsuranceUser = {
  _id?: string;
  id?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  mobileNumber?: string;
  userSubType?: string;
  insuranceFamily?: string | string[];
  insuranceFamilies?: string[];
  insurerFamily?: string | string[];
  insurerFamilies?: string[];
  billingCustomerInsurerFamily?: string | string[];
  insurerName?: string;
  insuranceCompanyName?: string;
  insurer?: { name?: string; family?: string | string[] };
  insuranceDetails?: { family?: string | string[] };
};

const GaraazOrderComponentHeader: React.FC<GaraazOrderComponentHeaderProps> = ({
  expandBody,
  etaMissed,
  setEtaMissed,
  orderStatus,
  orderData,
  activesupplierOrderStatus,
  transactionType,
  getSupplierBusinessName,
  getSupplierParentId,
  isBodyVisible,
  isCustomerOrderFreezed,
  isEnquiryLocked = false,
  getSupplierBranchName,
  getSupplierNumber,
  isEstimateRequired,
  isUrgent,
  partType,
  refetchAllOrders,
  onOpenCptUpdate,
}) => {
  const {
    orderLabel,
    isEnquiryOrder,
  }: { orderLabel: GetOrderLabels; isEnquiryOrder: boolean } = useOrderLabel();
  const toast = useNotification();
  const userDetails = useUserDetailsContext();
  const orderEtaFromStore = useOrdersStore(
    (state) => state.orderEtas[orderData._id],
  );
  const orderEta = useMemo(() => {
    const raw = orderEtaFromStore ?? orderData?.orderETA;
    return Array.isArray(raw) ? raw : [];
  }, [orderEtaFromStore, orderData?.orderETA]);
  const orderItems = useOrdersStore((state) => state.orderItems[orderData._id]);
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const isCustomerChatAllowed =
    mobileConfigs?.is_customer_chat_allowed_on_orca === "true" ||
    mobileConfigs?.is_customer_chat_allowed_on_orca === true;
  const { data: allSubscriptions } = useGetCustomerAllSubscriptions(
    orderData.customer._id,
  );
  const { data: insuranceUsersData, isLoading: isInsuranceUsersLoading } =
    useGetInsuranceUsers();
  const { data: allSuppliers } = useGetAllSuppliers();
  const { data: grazeons } = useGetGrazeons("EAGLE");

  const isPCFreezedPostPCEnd =
    mobileConfigs?.ff_freeze_order_items_post_part_conversion === "true" &&
    orderData?.metaInfo?.partConversionEndTime &&
    userDetails?.userSubType !== Roles.HEAD_OF_OPERATIONS;
  const isUserHeadOfOperations =
    userDetails?.userSubType === Roles.HEAD_OF_OPERATIONS;

  const showPaymentRoute = useMemo(() => {
    if (typeof orderData?.showPaymentRoute === "boolean") {
      return orderData.showPaymentRoute;
    }
    const singleInvoice =
      orderData?.billingDetails?.isSingleGaraazInvoiceRequired === true;
    const hasPayable = !!(orderData?.payableBy || orderData?.payableTo);
    if (isEnquiryOrder) return singleInvoice;
    if (singleInvoice) return false;
    return hasPayable;
  }, [
    isEnquiryOrder,
    orderData?.showPaymentRoute,
    orderData?.payableBy,
    orderData?.payableTo,
    orderData?.billingDetails?.isSingleGaraazInvoiceRequired,
  ]);

  const paymentRouteEditable = useMemo(() => {
    if (typeof orderData?.paymentRouteEditable === "boolean") {
      return orderData.paymentRouteEditable;
    }
    return (
      isEnquiryOrder &&
      orderData?.billingDetails?.isSingleGaraazInvoiceRequired === true
    );
  }, [
    isEnquiryOrder,
    orderData?.paymentRouteEditable,
    orderData?.billingDetails?.isSingleGaraazInvoiceRequired,
  ]);

  const isSupplierStatusEligibleForDashboard = useCallback(
    (supplierOrderStatus?: string) =>
      supplierOrderStatus === OrderStatus.IN_REVIEW,
    [],
  );

  const openSupplierDashboardForOrder = useCallback(
    (supplierId?: string) => {
      const baseUrl = getSupplierWebAppBaseUrl();
      const activeSupplierId =
        supplierId ||
        activesupplierOrderStatus?.supplierId ||
        orderData?.allocatedTo?.find((a: { isActive?: boolean }) => a.isActive)
          ?.supplierId;
      if (!baseUrl) {
        toast({
          title: "Supplier web URL is not configured",
          description:
            "Set REACT_APP_SUPPLIER_WEB_APP_URL for this environment.",
          status: "warning",
        });
        return;
      }
      if (!orderData?.orderNo || !activeSupplierId) {
        toast({
          title: "Cannot open supplier dashboard",
          description: "Missing order number or active supplier allocation.",
          status: "error",
        });
        return;
      }
      const url = buildSupplierWebOrderEditUrl(
        baseUrl,
        orderData.orderNo,
        activeSupplierId,
      );
      if (!url) {
        toast({
          title: "Cannot open supplier dashboard",
          description: "Could not build the supplier web link.",
          status: "error",
        });
        return;
      }
      window.open(url, "_blank", "noopener,noreferrer");
    },
    [
      activesupplierOrderStatus?.supplierId,
      orderData?.allocatedTo,
      orderData?.orderNo,
      toast,
    ],
  );

  const salesmanMap = useMemo(() => {
    if (!grazeons?.data || !Array.isArray(grazeons.data)) {
      return {};
    }

    return grazeons.data.reduce((map: any, grazeon: any) => {
      if (grazeon.user) {
        const firstName = grazeon.user.firstName || "";
        const lastName = grazeon.user.lastName || "";
        const name = [firstName, lastName].filter(Boolean).join(" ").trim();

        map[grazeon._id] = {
          name: name,
          mobileNumber: grazeon.user.mobileNumber,
        };
      }
      return map;
    }, {});
  }, [grazeons]);

  const [refreshedOutstanding, setRefreshedOutstanding] = useState<
    number | null
  >(null);
  const [isRefreshingOutstanding, setIsRefreshingOutstanding] = useState(false);

  const handleRefreshOutstanding = useCallback(async () => {
    const custId = orderData?.customer?._id;
    if (!custId) return;
    try {
      setIsRefreshingOutstanding(true);
      const data = await services.refreshOutstanding(custId);
      setRefreshedOutstanding(data?.outstandingAmount ?? 0);
    } catch {
      // keep existing value on error
    } finally {
      setIsRefreshingOutstanding(false);
    }
  }, [orderData?.customer?._id]);

  const [customerSupplierAssociations, setCustomerSupplierAssociations] =
    useState<{}[]>([]);

  const setScrollOrderId = useOrdersStore((state) => state.setScrollOrderId);
  const etaProvideClockValue0 = Math.floor(
    new Date(orderData.orderDate).getTime() / 1000,
  );
  const etaProvideClockValue100 =
    Math.floor(new Date(orderData.orderDate).getTime() / 1000) +
    mobileConfigs?.threshold_giving_eta_to_customer_mins * 60;

  let orderNotoShow = orderData.orderNo.split("-");
  orderNotoShow = orderNotoShow[orderNotoShow.length - 1];

  const customerDetailsToCopy = `
     ${orderData?.customer?.name}
     ${orderData?.shipmentAddress?.addressLine1}
     ${orderData?.shipmentAddress?.addressLine2}
     ${orderData?.shipmentAddress?.city}, ${
       orderData?.shipmentAddress?.state
     }, ${orderData?.shipmentAddress?.pinCode}
     ${orderData?.shipmentAddress?.country}
     ${formatMobileNumber(orderData.customer?.mobileNumber)}
     ${orderData?.customer?.code}
  `;

  const [etaProvideMissed, setEtaProvideMissed] = useState(false);
  const [vehicleType, setVehicleType] = useState(orderData?.PPDAmount ?? ""); //Todo: change PPDAound to vehicleType later on
  const latestETA = orderEta.length
    ? findLatestETAWithGivenTime(orderEta)?.latestTime
    : undefined;
  const cptGaraazSlot = useMemo(
    () => pickOrderEtaMinGaraazSlot(orderEta),
    [orderEta],
  );
  const renderEngagementModeBadge = () =>
    orderData?.customer?.engagementMode ? (
      <Badge
        ml={0}
        backgroundColor={`${
          orderData?.customer?.engagementMode === EngagementMode.PLATFORM
            ? "white"
            : orderData?.customer?.engagementMode === EngagementMode.EXPIRED
              ? "red.500"
              : "#FFD601"
        }`}
        color={
          orderData?.customer?.engagementMode === EngagementMode.EXPIRED
            ? "white"
            : "black"
        }
        outline={
          orderData?.customer?.engagementMode === EngagementMode.PLATFORM
            ? "1px solid #FFD601"
            : "none"
        }
        fontSize={"xx-small"}
        height={"fit-content"}
        flexShrink={0}
      >
        {orderData?.customer?.engagementMode === EngagementMode.SUBSCRIBED ||
        orderData?.customer?.engagementMode === EngagementMode.EXPIRED ? (
          <GaraazGeneralPopover
            ArekeysVisible={true}
            title={
              orderData?.customer?.engagementMode === EngagementMode.SUBSCRIBED
                ? "Subscription Details"
                : "Expired Subscription Details"
            }
            value={
              orderData?.customer?.engagementMode === EngagementMode.SUBSCRIBED
                ? ([
                    getActiveSubscriptionDetails(allSubscriptions, "UI"),
                  ].filter(Boolean) as any)
                : ([
                    getExpiredSubscriptionDetails(allSubscriptions, "UI"),
                  ].filter(Boolean) as any)
            }
            CopierKeys={[]}
            titleIcon={null}
          >
            <PopoverTrigger>
              <Text
                fontWeight="bold"
                textTransform={"capitalize"}
                cursor={"pointer"}
                fontSize={"1em"}
                display={"inline"}
                justifyContent={"center"}
              >
                {orderData?.customer?.engagementMode}
              </Text>
            </PopoverTrigger>
          </GaraazGeneralPopover>
        ) : (
          orderData?.customer?.engagementMode
        )}
      </Badge>
    ) : null;
  const deliveryStatusLabel = orderData?.cptSlab?.label ?? "";
  const isSelfPickupOrder =
    orderData?.cptSlab?.slabLevel === CPTSlabForManualOption.SELF_PICKUP;
  const rawDeliveryCost = orderData?.deliveryCost;
  const deliveryCostValue =
    rawDeliveryCost === null ||
    rawDeliveryCost === undefined ||
    rawDeliveryCost === ""
      ? NaN
      : Number(rawDeliveryCost);
  const hasDeliveryCost =
    Number.isFinite(deliveryCostValue) &&
    (!isSelfPickupOrder || deliveryCostValue > 0);
  const [customerType, setCustomerType] = useState(
    activesupplierOrderStatus?.customerType || "",
  );
  const [activerSupplierName, setActiveSupplierName] = useState("");
  const [customerDiscount, setCustomerDiscount] = useState(
    activesupplierOrderStatus?.discount || "",
  );

  const insuranceUsers = useMemo(() => {
    const spocSource =
      insuranceUsersData?.spocs?.data || insuranceUsersData?.spocs;
    const surveyorSource =
      insuranceUsersData?.surveyors?.data || insuranceUsersData?.surveyors;
    return {
      spocs: (Array.isArray(spocSource) ? spocSource : []) as InsuranceUser[],
      surveyors: (Array.isArray(surveyorSource)
        ? surveyorSource
        : []) as InsuranceUser[],
    };
  }, [insuranceUsersData?.spocs, insuranceUsersData?.surveyors]);

  const selectedInsuranceFamily = useMemo(
    () =>
      (orderData?.billingAddress?.billingCustomerInsurerFamily ||
        orderData?.billingDetails?.billingCustomerInsurerFamily ||
        orderData?.billingDetails?.insuranceFamily ||
        orderData?.billingDetails?.name ||
        "") as string,
    [
      orderData?.billingAddress?.billingCustomerInsurerFamily,
      orderData?.billingDetails?.billingCustomerInsurerFamily,
      orderData?.billingDetails?.insuranceFamily,
      orderData?.billingDetails?.name,
    ],
  );

  const [selectedSpocId, setSelectedSpocId] = useState<string>("");
  const [selectedSurveyorId, setSelectedSurveyorId] = useState<string>("");
  const [spocSearchQuery, setSpocSearchQuery] = useState<string>("");
  const [surveyorSearchQuery, setSurveyorSearchQuery] = useState<string>("");
  const [isEditingSpoc, setIsEditingSpoc] = useState(false);
  const [isEditingSurveyor, setIsEditingSurveyor] = useState(false);
  const [isEditingClaimId, setIsEditingClaimId] = useState(false);
  const [claimIdDraft, setClaimIdDraft] = useState("");
  const [isEditingIsZeroDepreciation, setIsEditingIsZeroDepreciation] =
    useState(false);
  const [isZeroDepreciationDraft, setIsZeroDepreciationDraft] = useState<
    boolean | ""
  >("");
  const [isSavingIsZeroDepreciation, setIsSavingIsZeroDepreciation] =
    useState(false);

  const normalizeFamily = (value?: string) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const extractFamilyValues = (value: any): string[] => {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.flatMap((item) => extractFamilyValues(item));
    }
    if (typeof value === "string") {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
    if (typeof value === "object") {
      // Handle possible API shapes for insurer family objects.
      return [
        value?.name,
        value?.label,
        value?.value,
        value?.family,
        value?.insurerFamily,
      ]
        .flatMap((item) => extractFamilyValues(item))
        .filter(Boolean);
    }
    return [String(value).trim()].filter(Boolean);
  };

  const getUserFamilies = useCallback((user: InsuranceUser): string[] => {
    return [
      user.insurerFamily,
      user.insurerFamilies,
      user.insurer?.family,
      (user as any)?.metaInfo?.insurerFamily,
      (user as any)?.profile?.insurerFamily,
      (user as any)?.data?.insurerFamily,
    ]
      .flatMap((family) => extractFamilyValues(family))
      .filter(Boolean);
  }, []);

  const filterUsersByFamily = useCallback(
    (users: InsuranceUser[]) => {
      const activeFamily = normalizeFamily(selectedInsuranceFamily);
      if (!activeFamily) return [];

      return users.filter((user) => {
        const families = getUserFamilies(user).map((family) =>
          normalizeFamily(family),
        );
        return families.includes(activeFamily);
      });
    },
    [getUserFamilies, selectedInsuranceFamily],
  );

  const filteredSpocs = useMemo(
    () => filterUsersByFamily(insuranceUsers.spocs),
    [filterUsersByFamily, insuranceUsers.spocs],
  );

  const filteredSurveyors = useMemo(
    () => filterUsersByFamily(insuranceUsers.surveyors),
    [filterUsersByFamily, insuranceUsers.surveyors],
  );

  const originalSub = useMemo(
    () => getActiveSubscriptionDetails(allSubscriptions, "ORIGINAL"),
    [allSubscriptions],
  );

  const isFreeDelivery = useMemo(() => {
    return originalSub?.plan_deliveries > originalSub?.taken_deliveries;
  }, [originalSub]);

  useEffect(() => {
    setCustomerSupplierAssociations(
      formatSupplierAssociationsForDisplay(
        orderData?.customer?.supplierAssociations,
        allSuppliers,
      ),
    );
    setVehicleType(orderData?.PPDAmount ?? "");
    setEtaProvideMissed(false);

    setCustomerType(activesupplierOrderStatus?.customerType || "");
    setCustomerDiscount(activesupplierOrderStatus?.discount || 0);
    setActiveSupplierName(
      getSupplierBusinessName(activesupplierOrderStatus?.supplierId),
    );
  }, [
    orderData,
    allSuppliers,
    activesupplierOrderStatus?.supplierId,
    getSupplierBusinessName,
  ]);

  useEffect(() => {
    const matchSpoc = filteredSpocs.find(
      (user) =>
        (user._id || user.id) === orderData?.spocDetails?._id ||
        normalizeFamily(
          user.name || `${user.firstName || ""} ${user.lastName || ""}`,
        ) === normalizeFamily(orderData?.spocDetails?.name),
    );
    const matchSurveyor = filteredSurveyors.find(
      (user) =>
        (user._id || user.id) === orderData?.surveyorDetails?._id ||
        normalizeFamily(
          user.name || `${user.firstName || ""} ${user.lastName || ""}`,
        ) === normalizeFamily(orderData?.surveyorDetails?.name),
    );

    setSelectedSpocId(matchSpoc?._id || "");
    setSelectedSurveyorId(matchSurveyor?._id || "");
  }, [
    filteredSpocs,
    filteredSurveyors,
    orderData?.spocDetails?._id,
    orderData?.spocDetails?.name,
    orderData?.surveyorDetails?._id,
    orderData?.surveyorDetails?.name,
  ]);

  function preparePopverAddressObject(
    shipmentAddress: any,
    includeMobileNumber: boolean = true,
  ) {
    if (!shipmentAddress) return [];
    const address: any = {
      addressLine1: shipmentAddress?.addressLine1,
      addressLine2: shipmentAddress?.addressLine2,
      addressLine3:
        shipmentAddress?.city +
        ", " +
        shipmentAddress?.state +
        ", " +
        shipmentAddress?.pinCode,
      country: shipmentAddress?.country,
    };
    if (includeMobileNumber) {
      // Mobile number removed as per user request
    }

    return [address];
  }

  function prepareBillingInfoArray() {
    return orderData.billingDetails
      ? [
          {
            Name: orderData.billingDetails?.name ?? "-",
            GST: orderData.billingDetails?.gst ?? "-",
            "Supporting Bill Required": orderData.billingDetails
              ?.isSupportingBillRequired
              ? "Yes"
              : "No",
          },
        ]
      : [];
  }

  function prepareCreditInfoArray(customer: any) {
    if (!customer?.creditLimit && !customer?.outstandingAmount) {
      return [];
    }
    const displayOutstanding =
      refreshedOutstanding !== null
        ? refreshedOutstanding
        : customer?.outstandingAmount > 0
          ? customer?.outstandingAmount
          : 0;
    const outstandingValue = (
      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {formatCurrency(displayOutstanding)}
        <IconButton
          aria-label="View Outstanding Details"
          icon={<BiShow />}
          size="xs"
          variant="ghost"
          ml={1}
          onClick={() =>
            window.open(
              `${paths.unpaidOrders}?customerId=${customer?._id}`,
              "_blank",
            )
          }
        />
        <Tooltip label="Refresh Outstanding">
          <IconButton
            aria-label="Refresh Outstanding"
            icon={<FaSyncAlt />}
            size="xs"
            variant="ghost"
            isLoading={isRefreshingOutstanding}
            onClick={handleRefreshOutstanding}
          />
        </Tooltip>
      </span>
    );
    return [
      {
        "Credit Limit": formatCurrency(
          customer?.creditLimit > 0 ? customer?.creditLimit : 0,
        ),
        Outstanding: outstandingValue,
      },
    ];
  }

  function prepareSalesmanInfoArray(customer: any) {
    const salesmanInfo = salesmanMap[customer?.salesmanId];

    return [
      {
        Salesman: salesmanInfo?.name || "N/A",
        "Mobile Number": formatMobileNumber(salesmanInfo?.mobileNumber),
      },
    ];
  }

  function prepareSPOCInfoArray(customer: any) {
    const contactPersons = customer?.contactPersons || [];
    const spoc = contactPersons.length > 0 ? contactPersons[0] : null;

    const displayName = spoc?.name || customer?.name || "--";
    const displayMobile = spoc?.mobileNumber || customer?.mobileNumber || "";
    const displayNote = spoc?.note || "--";

    const spocNameWithIcon = (
      <HStack spacing={2} alignItems="center">
        <Tooltip
          label={displayName}
          isDisabled={!displayName || displayName.length <= 20}
        >
          <Text fontSize="sm" noOfLines={1} maxWidth="150px">
            {displayName}
          </Text>
        </Tooltip>
        <ContactPersonsNestedPopover contactPersons={contactPersons} />
      </HStack>
    );

    const spocNote = (
      <Tooltip
        label={displayNote}
        isDisabled={!displayNote || displayNote.length <= 20}
      >
        <Text fontSize="sm" noOfLines={1} maxWidth="200px">
          {displayNote}
        </Text>
      </Tooltip>
    );

    const spocMobileNumber = displayMobile ? (
      <HStack spacing={1}>
        <Text fontSize="sm">{formatMobileNumber(displayMobile)}</Text>
        <GarrazCopyText
          text={getNationalMobileForCopy(displayMobile)}
          popOverMessage="SPOC Number Copied"
        />
      </HStack>
    ) : (
      "--"
    );

    return [
      {
        Name: spocNameWithIcon,
        "Mobile No.": spocMobileNumber,
        Note: spocNote,
      },
    ];
  }

  function getActiveSubscriptionDetails(
    allSubscriptions: any,
    format: "UI" | "ORIGINAL",
  ) {
    if (!allSubscriptions) return;

    let activeSubscription;
    for (let i = 0; i < allSubscriptions.length; i++) {
      const endDate = new Date(allSubscriptions[i].endDate);
      const startDate = new Date(allSubscriptions[i].startDate);
      if (endDate >= new Date() && startDate <= new Date()) {
        activeSubscription = allSubscriptions[i];
        break;
      }
    }

    if (!activeSubscription) {
      return;
    }

    return format === "UI"
      ? {
          "Start Date": activeSubscription.startDate
            ? formatInDateMonthYearUTC(activeSubscription.startDate)
            : "",
          "End Date": activeSubscription.endDate
            ? formatInDateMonthYearUTC(activeSubscription.endDate)
            : "",
          Amount: "₹" + (activeSubscription.amount ?? ""),
          "Plan Deliveries":
            activeSubscription.plan_deliveries > 1000 ? (
              <BiInfinite></BiInfinite>
            ) : (
              activeSubscription.plan_deliveries
            ),
          "Taken Deliveries": activeSubscription.taken_deliveries ?? "",
        }
      : activeSubscription;
  }

  const backUrlPrefix = new URL(window.location.href)?.origin;
  const backUrl = `${backUrlPrefix}/add-catalog-part/${orderNotoShow}/{item_id}`;
  const oemUrl = orderData.oemUrl;
  const oemRedirectURL = oemUrl
    ? `${oemUrl}?back_url_id=${encodeURIComponent(backUrl)}`
    : "";
  const [isCarModalVisible, setIsCarModalVisible] = useState(false);
  const [vehicleSearchValues, setVehicleSearchValues] = useState<{
    carMaker?: string;
    modelLine?: string;
    year?: string;
    modification?: string;
    oemBrandUrl?: string;
    oemUrl?: string;
    licensePlateNumber?: string;
    isCarMakerPreFilled?: boolean;
    isModelLinePreFilled?: boolean;
    isYearPreFilled?: boolean;
    isModificationPreFilled?: boolean;
    isLicensePlateNumberPreFilled?: boolean;
  }>({});
  const [errorMessage, setErrorMessage] = useState("");

  const openCarModal = useCallback(() => {
    setVehicleSearchValues({});
    setIsCarModalVisible(true);
  }, []);

  const closeCarModal = useCallback(() => {
    setIsCarModalVisible(false);
  }, []);

  const handleVehicleSearchValueChange = useCallback(
    (field: string, value: any) => {
      setVehicleSearchValues((prev) => ({
        ...prev,
        [field]: value,
      }));
    },
    [],
  );

  const handleVehicleSearchConfirm = async (values: any) => {
    const { carMaker, modelLine, year, modification } = values;
    if (!modification?.oemUrl) return;
    const oemUrl = modification?.oemUrl;
    const licensePlateNumber = vehicleSearchValues.licensePlateNumber;

    try {
      const updateData: any = {
        oemUrl,
      };
      if (carMaker?.label && modelLine?.label && year && modification?.label) {
        const selectedCarModel = `${carMaker.label} ${modelLine.label} ${year} ${modification.label}`;
        updateData.carModel = selectedCarModel.replace(" ⭐", "");
      }
      if (licensePlateNumber) {
        updateData.licensePlateNumber = licensePlateNumber;
      }

      await services.updateOrder(orderData._id, updateData);

      if (licensePlateNumber && vehicleSearchValues.modification) {
        const vehicleUpdateData = {
          oemUrl,
          configurationId: vehicleSearchValues.modification
            ? +vehicleSearchValues.modification
            : undefined,
          makerId: vehicleSearchValues.carMaker
            ? +vehicleSearchValues.carMaker
            : undefined,
          lineId: vehicleSearchValues.modelLine
            ? +vehicleSearchValues.modelLine
            : undefined,
          year: vehicleSearchValues.year
            ? +vehicleSearchValues.year
            : undefined,
        };

        await services.updateVehicleByLPN(
          licensePlateNumber,
          vehicleUpdateData,
        );
      }
    } catch (error) {
      console.log(error);
    }
    setIsCarModalVisible(false);
    setVehicleSearchValues({});
    const catalogueSourceURI = `${oemUrl}?back_url_id=${encodeURIComponent(
      backUrl,
    )}`;
    window.open(catalogueSourceURI, "_blank");
  };

  const handleVehicleSearchError = useCallback(
    (errorMessage: string) => {
      toast({
        description: errorMessage,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
    [toast],
  );

  const handleLpnSearch = useCallback(
    async (licensePlateNumber: string) => {
      try {
        const vehicleData = await services.getVehicleByLPN(licensePlateNumber);

        const makerId = vehicleData.makerId;
        const lineId = vehicleData.lineId;
        const year = vehicleData.year;
        const configurationId = vehicleData.configurationId;
        const oemUrl = vehicleData.oemUrl;
        const numberPlate = vehicleData.numberPlate;

        if (oemUrl) {
          const updateData: any = {
            oemUrl,
          };
          if (numberPlate) {
            updateData.licensePlateNumber = numberPlate;
          }

          await services.updateOrder(orderData._id, updateData);
          setIsCarModalVisible(false);
          setVehicleSearchValues({});
          const oemWithBack = `${oemUrl}?back_url_id=${encodeURIComponent(
            backUrl,
          )}`;
          window.open(oemWithBack, "_blank");
          return;
        }

        if (vehicleData && makerId) {
          setVehicleSearchValues((prev) => ({
            ...prev,
            licensePlateNumber: numberPlate,
            carMaker: makerId?.toString(),
            modelLine: lineId?.toString(),
            year: year?.toString(),
            modification: configurationId?.toString(),
            oemUrl: oemUrl,
            isCarMakerPreFilled: !!makerId,
            isModelLinePreFilled: !!lineId,
            isYearPreFilled: !!year,
            isModificationPreFilled: !!configurationId,
            isLicensePlateNumberPreFilled: !!numberPlate,
          }));
        } else {
          setVehicleSearchValues({});
          toast({
            description: "No vehicle information found for this LPN",
            status: "warning",
            duration: 3000,
            isClosable: true,
          });
        }
        setIsCarModalVisible(true);
      } catch (error: any) {
        toast({
          description:
            error.message || "Error searching for vehicle information",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    },
    [toast, orderData._id, backUrl],
  );

  const isVehicleSearchValuesValid = useMemo(() => {
    const hasCarMaker = !!vehicleSearchValues.carMaker;
    const hasModelLine = !!vehicleSearchValues.modelLine;
    const hasYear = !!vehicleSearchValues.year;
    const hasModification = !!vehicleSearchValues.modification;
    const hasOemUrl = !!vehicleSearchValues.oemUrl;
    setErrorMessage("");

    if (hasModification && !hasOemUrl) {
      setErrorMessage("Catalogue is not available for this vehicle");
      return false;
    }

    return (
      hasCarMaker && hasModelLine && hasYear && hasModification && hasOemUrl
    );
  }, [vehicleSearchValues]);

  const handleOnclickCatalog = async () => {
    if (oemRedirectURL) {
      window.open(oemRedirectURL, "_blank");
    } else if (orderData.licensePlateNumber) {
      setVehicleSearchValues({
        licensePlateNumber: orderData.licensePlateNumber,
      });
      await handleLpnSearch(orderData.licensePlateNumber);
    } else {
      openCarModal();
    }
  };

  function getExpiredSubscriptionDetails(
    allSubscriptions: any,
    format: "UI" | "ORIGINAL",
  ) {
    if (!allSubscriptions) return;
    let maxEndDate = new Date("1970/01/01");
    let maxEndDateSubscription;

    for (let i = 0; i < allSubscriptions.length; i++) {
      const endDate = new Date(allSubscriptions[i].endDate);
      if (endDate > maxEndDate && endDate < new Date()) {
        maxEndDate = endDate;
        maxEndDateSubscription = allSubscriptions[i];
      }
    }

    if (!maxEndDateSubscription) {
      return;
    }

    return format === "UI"
      ? {
          "Start Date": maxEndDateSubscription.startDate
            ? formatInDateMonthYearUTC(maxEndDateSubscription.startDate)
            : "",
          "End Date": maxEndDateSubscription.endDate
            ? formatInDateMonthYearUTC(maxEndDateSubscription.endDate)
            : "",
          Amount: "₹" + (maxEndDateSubscription.amount ?? ""),
          "Plan Deliveries":
            maxEndDateSubscription.plan_deliveries > 1000 ? (
              <BiInfinite></BiInfinite>
            ) : (
              maxEndDateSubscription.plan_deliveries
            ),
          "Taken Deliveries": maxEndDateSubscription.taken_deliveries ?? "",
        }
      : maxEndDateSubscription;
  }

  async function handleVehicleTypeSubmit() {
    try {
      if (vehicleType < 1 || vehicleType > 5) {
        toast({
          description: "Invalid Vehicle Type",
          status: "error",
        });
        return;
      }
      const response = await services.updateOrder(orderData._id, {
        PPDAmount: vehicleType,
      });
      toast({
        description: "Vehicle Type updated successfully",
        status: "success",
      });
      refetchAllOrders();
    } catch (error) {
      toast({
        description: "Some error occured in Updating Vehicle Type",
        status: "error",
      });
    }
  }

  async function handleMetaInfoChange() {
    try {
      const response = await services.updateOrder(orderData._id, {
        customerType,
        discount: +customerDiscount,
      });
      toast({
        description: "Customer meta info updated successfully",
        status: "success",
      });
    } catch (error) {
      toast({
        description: "Some error occured in Updating customer meta info",
        status: "error",
      });
    }
  }

  async function onEtaProvideTimeComplete() {
    //These API calls from throwing ETA missed event Are supressed, as they are overloading BE
    // const response = await services.throwETAProvideMissedEvent(orderData._id);
  }

  async function onEtaTimeComplete() {
    //These API calls from throwing ETA missed event Are supressed, as they are overloading BE
    // const response = await services.throwETAMissedEvent(
    //   orderData._id,
    //   findLatestETAWithGivenTime(orderEta).latestGivenTime,
    //   findLatestETAWithGivenTime(orderEta).latestTime
    // );
  }

  const formatSupplierNumber = (
    supplierId: string,
    branchId: string | undefined,
  ) => {
    const supplierNumber = getSupplierNumber(supplierId, branchId);
    if (!supplierNumber) return "";
    const formatted = formatMobileNumber(supplierNumber);
    return formatted !== "" ? formatted : supplierNumber;
  };

  const latestEtaResult = orderEta.length
    ? findLatestETAWithGivenTime(orderEta)
    : null;
  const latestETAInSeconds = latestEtaResult?.latestTime
    ? new Date(latestEtaResult.latestTime).getTime() / 1000
    : NaN;
  const latestETAGivenTimeInSeconds = latestEtaResult?.latestGivenTime
    ? new Date(latestEtaResult.latestGivenTime).getTime() / 1000
    : NaN;
  const isPlatformInfiniteEta =
    latestETAInSeconds === epochPlatformEtaSeconds;
  const isCountdownExpired =
    !isPlatformInfiniteEta &&
    Number.isFinite(latestETAInSeconds) &&
    latestETAInSeconds * 1000 <= Date.now();
  // Avoid one-frame "info icon only" flash when ETA is already past on mount
  const showMissedEta = etaMissed || isCountdownExpired;

  const shouldShowAsMissed = isEstimateRequired
    ? isEnquiryEtaMissed(orderEta, orderData?.metaInfo?.estimateSharedAt)
    : true; // for confirmed orders previous logic is enough

  const getInsuranceUserName = (user: InsuranceUser) =>
    (user.name || `${user.firstName || ""} ${user.lastName || ""}`).trim();

  const handleInsuranceUserChange = async (
    type: "spoc" | "surveyor",
    userId: string,
  ) => {
    const source = type === "spoc" ? filteredSpocs : filteredSurveyors;
    const selectedUser = source.find(
      (user) => (user._id || user.id) === userId,
    );
    if (!selectedUser) return;
    const currentDetails =
      type === "spoc" ? orderData?.spocDetails : orderData?.surveyorDetails;
    const selectedResolvedId = String(
      selectedUser._id || selectedUser.id || "",
    );
    const currentResolvedId = String(currentDetails?._id || "");
    const selectedName = getInsuranceUserName(selectedUser);
    const currentName = String(currentDetails?.name || "").trim();
    const selectedMobile = String(selectedUser.mobileNumber || "").trim();
    const currentMobile = String(currentDetails?.mobileNumber || "").trim();

    if (
      (selectedResolvedId && selectedResolvedId === currentResolvedId) ||
      (selectedName &&
        selectedName === currentName &&
        selectedMobile === currentMobile)
    ) {
      return;
    }

    const payload =
      type === "spoc"
        ? {
            spocDetails: {
              _id: selectedUser._id || selectedUser.id,
              name: getInsuranceUserName(selectedUser),
              mobileNumber: selectedUser.mobileNumber || "",
            },
          }
        : {
            surveyorDetails: {
              _id: selectedUser._id || selectedUser.id,
              name: getInsuranceUserName(selectedUser),
              mobileNumber: selectedUser.mobileNumber || "",
            },
          };

    try {
      await services.updateOrder(orderData._id, payload);
      if (type === "spoc") {
        setSelectedSpocId(userId);
        setIsEditingSpoc(false);
        setSpocSearchQuery("");
      } else {
        setSelectedSurveyorId(userId);
        setIsEditingSurveyor(false);
        setSurveyorSearchQuery("");
      }
      toast({
        description: `${
          type === "spoc" ? "Insurance SPOC" : "Insurance Surveyor"
        } updated`,
        status: "success",
      });
      refetchAllOrders();
    } catch (error) {
      toast({
        description: `Failed to update insurance ${
          type === "spoc" ? "SPOC" : "Surveyor"
        }`,
        status: "error",
      });
    }
  };

  const handleSaveInsuranceClaimId = async () => {
    const trimmed = claimIdDraft.trim();
    const current = String(orderData.insuranceClaimId || "").trim();
    if (trimmed === current) {
      setIsEditingClaimId(false);
      return;
    }
    try {
      await services.updateOrder(orderData._id, {
        insuranceClaimId: trimmed,
      });
      toast({
        description: "Claim ID updated",
        status: "success",
      });
      setIsEditingClaimId(false);
      refetchAllOrders();
    } catch {
      toast({
        description: "Failed to update Claim ID",
        status: "error",
      });
    }
  };

  const resolveIsZeroDepreciation = (
    order: any,
  ): boolean | null => {
    const value = order?.isZeroDepreciation;
    if (value === true || value === "true") return true;
    if (value === false || value === "false") return false;
    // Legacy field from earlier zdType rollout
    if (order?.zdType === "ZD") return true;
    if (order?.zdType === "NonZD" || order?.zdType === "Non-ZD") return false;
    return null;
  };

  const currentIsZeroDepreciation = resolveIsZeroDepreciation(orderData);

  const zeroDepreciationLabel = (value?: boolean | null) => {
    if (value === true) return "Zero Depreciation";
    if (value === false) return "Non Zero Depreciation";
    return "-";
  };

  const handleSaveIsZeroDepreciation = async () => {
    if (isSavingIsZeroDepreciation) return;
    if (isZeroDepreciationDraft === "") {
      toast({
        description: "Please select Depreciation Type",
        status: "warning",
      });
      return;
    }
    if (isZeroDepreciationDraft === currentIsZeroDepreciation) {
      setIsEditingIsZeroDepreciation(false);
      return;
    }
    try {
      setIsSavingIsZeroDepreciation(true);
      await services.updateOrder(orderData._id, {
        isZeroDepreciation: isZeroDepreciationDraft,
      });
      toast({
        description: "Depreciation Type updated",
        status: "success",
      });
      setIsEditingIsZeroDepreciation(false);
      refetchAllOrders();
    } catch {
      toast({
        description: "Failed to update Depreciation Type",
        status: "error",
      });
    } finally {
      setIsSavingIsZeroDepreciation(false);
    }
  };

  const renderInsuranceUserDropdown = (
    users: InsuranceUser[],
    selectedId: string,
    loadingLabel: string,
    emptyLabel: string,
    searchQuery: string,
    setSearchQuery: React.Dispatch<React.SetStateAction<string>>,
    onSelect: (userId: string) => void,
  ) => {
    const selectedUser = users.find(
      (user) => (user._id || user.id) === selectedId,
    );
    const selectedLabel = selectedUser
      ? getInsuranceUserName(selectedUser)
      : emptyLabel;
    const normalizedQuery = searchQuery.trim().toLowerCase();
    const searchableUsers = normalizedQuery
      ? users.filter((user) =>
          getInsuranceUserName(user).toLowerCase().includes(normalizedQuery),
        )
      : users;

    return (
      <Menu placement="right-start">
        <MenuButton
          as={Button}
          size="xs"
          variant="outline"
          rightIcon={<ChevronDownIcon />}
          width="160px"
          minWidth="160px"
          maxWidth="160px"
          fontWeight="normal"
          textAlign="left"
        >
          <Text fontSize="xs" noOfLines={1}>
            {isInsuranceUsersLoading ? loadingLabel : selectedLabel}
          </Text>
        </MenuButton>
        <MenuList zIndex={2000} maxH="220px" overflowY="auto">
          <Box px={2} py={2}>
            <Input
              size="xs"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </Box>
          {!searchableUsers.length ? (
            <MenuItem isDisabled>{emptyLabel}</MenuItem>
          ) : (
            searchableUsers.map((user) => (
              <MenuItem
                key={user._id || user.id}
                onClick={() => onSelect(String(user._id || user.id))}
              >
                {getInsuranceUserName(user)}
              </MenuItem>
            ))
          )}
        </MenuList>
      </Menu>
    );
  };

  const handleInsuranceDetailsPopoverClose = () => {
    // Keep in-progress edits if a save is running; otherwise reset draft state.
    if (isSavingIsZeroDepreciation) return;
    setIsEditingSpoc(false);
    setIsEditingSurveyor(false);
    setIsEditingClaimId(false);
    setClaimIdDraft("");
    setIsEditingIsZeroDepreciation(false);
    setIsZeroDepreciationDraft("");
    setSpocSearchQuery("");
    setSurveyorSearchQuery("");
  };

  return (
    <>
      <HStack
        // Always content-sized. A fixed 25% height left no room for the
        // LPN/tag strip, which clipped the footer and broke invoice hover.
        // Body (flex:1, minH:0) absorbs the remaining card height.
        height="auto"
        flexShrink={0}
        py={"0.4rem"}
        px={"0.5rem"}
        justifyContent={"space-between"}
        backgroundColor={"#f0f6f6"}
        boxSizing="border-box"
        style={{ margin: 0 }}
        position={"relative"}
      >
        {!startOrcaStates.includes(orderStatus) && (
          <IconButton
            width={"1.2em"}
            height={"1.2em"}
            lineHeight={1}
            minWidth={"none"}
            aria-label=""
            borderRadius={"50%"}
            position={"absolute"}
            bottom={-2}
            left={"50%"}
            onClick={expandBody}
            isDisabled={startOrcaStates.includes(orderStatus)}
            icon={
              !isBodyVisible ? (
                <BiChevronDown></BiChevronDown>
              ) : (
                <BiChevronUp></BiChevronUp>
              )
            }
          ></IconButton>
        )}

        <HStack
          width={"70%"}
          spacing={6}
          height="auto"
          alignItems={"flex-start"}
          justifyContent={"space-between"}
        >
          <Box
        height="auto"
        display={"flex"}
        flexDirection={"column"}
      >
            <Text fontWeight={"bold"} fontSize={"small"} color={"#1A202C"}>
              {orderData.orderType === "SUBSCRIPTION"
                ? "SUBSCRIPTION ORDER"
                : `${orderLabel.toUpperCase()} PLACED`}
            </Text>
            <Text fontSize={"xs"}>
              {formatDate(
                isEnquiryOrder
                  ? (orderData?.orderDate ?? orderData?.createdAt)
                  : orderData?.createdAt,
              )}
            </Text>
            <Text fontSize={"xs"}>
              {formatTime(
                isEnquiryOrder
                  ? (orderData?.orderDate ?? orderData?.createdAt)
                  : orderData?.createdAt,
              )}
            </Text>
            <Box marginTop="0.35rem">
              {isEstimateRequired &&
                orderData.requiresEstimateByCustomer !== false && (
                  <Badge
                    backgroundColor={"red.500"}
                    fontSize={"xx-small"}
                    height={"fit-content"}
                    outline={"none"}
                    color={"white"}
                    mr={2}
                  >
                    Estimate
                  </Badge>
                )}
              {isEnquiryOrder && (
                <Badge
                  backgroundColor={
                    getEnquiryStatus(orderItems, orderStatus) === "OPEN"
                      ? "#1E7F43"
                      : "#6C757D"
                  }
                  fontSize={"xx-small"}
                  height={"fit-content"}
                  outline={"none"}
                  color={"white"}
                  mr={2}
                >
                  {getEnquiryStatus(orderItems, orderStatus)}
                </Badge>
              )}
              {orderData?.carMaker && (
                <Badge
                  backgroundColor={"blue.500"}
                  fontSize={"xx-small"}
                  height={"fit-content"}
                  outline={"none"}
                  color={"white"}
                  mr={2}
                >
                  {orderData?.carMaker}
                </Badge>
              )}
              {orderData.billingDetails?.billingEntity ===
                BillingEntity.INSURANCE_COMPANY && (
                <GaraazGeneralPopover
                  ArekeysVisible={true}
                  CopierKeys={["Surveyor Number", "SPOC Number"]}
                  title="Insurance Details"
                  keyMinWidth="130px"
                  contentMinWidth="420px"
                  value={[
                    {
                      Name: orderData.billingDetails?.name || "-",
                      "Claim ID":
                        isEnquiryOrder && !isEnquiryLocked ? (
                          <HStack
                            spacing={1}
                            alignItems="center"
                            flexWrap="nowrap"
                            width="fit-content"
                          >
                            {isEditingClaimId ? (
                              <>
                                <Input
                                  size="xs"
                                  width="140px"
                                  minWidth="140px"
                                  maxWidth="140px"
                                  maxLength={128}
                                  value={claimIdDraft}
                                  onChange={(e) =>
                                    setClaimIdDraft(e.target.value)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  onKeyDown={(e) => e.stopPropagation()}
                                />
                                <IconButton
                                  aria-label="Save Claim ID"
                                  icon={<CheckIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    void handleSaveInsuranceClaimId();
                                  }}
                                />
                                <IconButton
                                  aria-label="Cancel Claim ID edit"
                                  icon={<CloseIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEditingClaimId(false);
                                    setClaimIdDraft("");
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Text fontSize="sm" maxW="160px" noOfLines={1}>
                                  {orderData.insuranceClaimId || "-"}
                                </Text>
                                {!!orderData.insuranceClaimId && (
                                  <GarrazCopyText
                                    text={orderData.insuranceClaimId}
                                    popOverMessage="Claim ID Copied"
                                  />
                                )}
                                <IconButton
                                  aria-label="Edit Claim ID"
                                  icon={<EditOutlinedIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  ml={2}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setClaimIdDraft(
                                      orderData.insuranceClaimId || "",
                                    );
                                    setIsEditingClaimId(true);
                                  }}
                                />
                              </>
                            )}
                          </HStack>
                        ) : (
                          <HStack
                            spacing={1}
                            alignItems="center"
                            flexWrap="nowrap"
                            width="fit-content"
                          >
                            <Text fontSize="sm" maxW="160px" noOfLines={1}>
                              {orderData.insuranceClaimId || "-"}
                            </Text>
                            {!!orderData.insuranceClaimId && (
                              <GarrazCopyText
                                text={orderData.insuranceClaimId}
                                popOverMessage="Claim ID Copied"
                              />
                            )}
                          </HStack>
                        ),
                      "Depreciation Type":
                        isEnquiryOrder && !isEnquiryLocked ? (
                          <HStack
                            spacing={1}
                            alignItems="center"
                            flexWrap="nowrap"
                            width="fit-content"
                          >
                            {isEditingIsZeroDepreciation ? (
                              <>
                                <Select
                                  isDisabled={isSavingIsZeroDepreciation}
                                  size="xs"
                                  width="190px"
                                  minWidth="190px"
                                  maxWidth="190px"
                                  value={
                                    isZeroDepreciationDraft === ""
                                      ? ""
                                      : String(isZeroDepreciationDraft)
                                  }
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    if (value === "") {
                                      setIsZeroDepreciationDraft("");
                                      return;
                                    }
                                    setIsZeroDepreciationDraft(value === "true");
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  <option value="true">
                                    Zero Depreciation
                                  </option>
                                  <option value="false">
                                    Non Zero Depreciation
                                  </option>
                                </Select>
                                <IconButton
                                  isDisabled={isSavingIsZeroDepreciation}
                                  aria-label="Save Depreciation Type"
                                  icon={<CheckIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    void handleSaveIsZeroDepreciation();
                                  }}
                                />
                                <IconButton
                                  isDisabled={isSavingIsZeroDepreciation}
                                  aria-label="Cancel Depreciation Type edit"
                                  icon={<CloseIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEditingIsZeroDepreciation(false);
                                    setIsZeroDepreciationDraft("");
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Text fontSize="sm" maxW="200px" noOfLines={1}>
                                  {zeroDepreciationLabel(
                                    currentIsZeroDepreciation,
                                  )}
                                </Text>
                                <IconButton
                                  aria-label="Edit Depreciation Type"
                                  icon={<EditOutlinedIcon fontSize="small" />}
                                  size="xs"
                                  variant="ghost"
                                  ml={2}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsZeroDepreciationDraft(
                                      currentIsZeroDepreciation === null
                                        ? ""
                                        : currentIsZeroDepreciation,
                                    );
                                    setIsEditingIsZeroDepreciation(true);
                                  }}
                                />
                              </>
                            )}
                          </HStack>
                        ) : (
                          <Text fontSize="sm" maxW="200px" noOfLines={1}>
                            {zeroDepreciationLabel(currentIsZeroDepreciation)}
                          </Text>
                        ),
                      Remarks: (
                        <Text
                          fontSize="sm"
                          maxW="240px"
                          whiteSpace="pre-wrap"
                          noOfLines={3}
                        >
                          {orderData.customerRemarks?.trim()
                            ? orderData.customerRemarks
                            : "-"}
                        </Text>
                      ),
                      "SPOC Name": (
                        <HStack
                          spacing={2}
                          alignItems="center"
                          flexWrap="nowrap"
                        >
                          {isEnquiryOrder && isEditingSpoc ? (
                            renderInsuranceUserDropdown(
                              filteredSpocs,
                              selectedSpocId,
                              "Loading SPOCs...",
                              "Select SPOC",
                              spocSearchQuery,
                              setSpocSearchQuery,
                              (userId) =>
                                handleInsuranceUserChange("spoc", userId),
                            )
                          ) : (
                            <Text
                              fontSize="sm"
                              width="160px"
                              minWidth="160px"
                              maxWidth="160px"
                              noOfLines={1}
                            >
                              {orderData.spocDetails?.name || "-"}
                            </Text>
                          )}
                          {isEnquiryOrder && !isEnquiryLocked && (
                            <IconButton
                              aria-label="Edit SPOC"
                              icon={<EditOutlinedIcon fontSize="small" />}
                              size="xs"
                              variant="ghost"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsEditingSpoc((prev) => !prev);
                                setSpocSearchQuery("");
                              }}
                            />
                          )}
                        </HStack>
                      ),
                      ...(orderData.spocDetails?.name &&
                      orderData.spocDetails?.mobileNumber
                        ? {
                            "SPOC Number": formatMobileNumber(
                              orderData.spocDetails.mobileNumber,
                            ),
                          }
                        : {}),
                      "Surveyor Name": (
                        <HStack
                          spacing={2}
                          alignItems="center"
                          flexWrap="nowrap"
                        >
                          {isEnquiryOrder && isEditingSurveyor ? (
                            renderInsuranceUserDropdown(
                              filteredSurveyors,
                              selectedSurveyorId,
                              "Loading Surveyors...",
                              "Select Surveyor",
                              surveyorSearchQuery,
                              setSurveyorSearchQuery,
                              (userId) =>
                                handleInsuranceUserChange("surveyor", userId),
                            )
                          ) : (
                            <Text
                              fontSize="sm"
                              width="160px"
                              minWidth="160px"
                              maxWidth="160px"
                              noOfLines={1}
                            >
                              {orderData.surveyorDetails?.name || "-"}
                            </Text>
                          )}
                          {isEnquiryOrder && !isEnquiryLocked && (
                            <IconButton
                              aria-label="Edit Surveyor"
                              icon={<EditOutlinedIcon fontSize="small" />}
                              size="xs"
                              variant="ghost"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsEditingSurveyor((prev) => !prev);
                                setSurveyorSearchQuery("");
                              }}
                            />
                          )}
                        </HStack>
                      ),
                      ...(orderData.surveyorDetails?.name &&
                      orderData.surveyorDetails?.mobileNumber
                        ? {
                            "Surveyor Number": formatMobileNumber(
                              orderData.surveyorDetails.mobileNumber,
                            ),
                          }
                        : {}),
                      "Surveyor Remarks":
                        orderData.surveyorDetails?.remarks || "-",
                    },
                  ]}
                  // Click trigger: hover + native <Select> is unreliable (dropdown
                  // leaves the popover and closes it, clearing draft/selection).
                  trigger={"click"}
                  onClose={handleInsuranceDetailsPopoverClose}
                >
                  <PopoverTrigger>
                    <Badge
                      backgroundColor={"red.500"}
                      fontSize={"xx-small"}
                      height={"fit-content"}
                      outline={"none"}
                      color={"white"}
                      mr={2}
                      cursor={"pointer"}
                    >
                      INSURANCE
                    </Badge>
                  </PopoverTrigger>
                </GaraazGeneralPopover>
              )}
              {partType?.length > 0 && (
                <>
                  {partType.map((type, index) => (
                    <Badge
                      key={index}
                      backgroundColor={"purple.500"}
                      fontSize={"xx-small"}
                      height={"fit-content"}
                      outline={"none"}
                      color={"white"}
                      mr={2}
                    >
                      {type}
                    </Badge>
                  ))}
                </>
              )}
              {isEnquiryOrder &&
                orderData.billingDetails?.isSingleGaraazInvoiceRequired && (
                  <Badge
                    backgroundColor="#2B5CA6"
                    fontSize="xx-small"
                    height="fit-content"
                    outline="none"
                    color="white"
                    mr={2}
                    textTransform="uppercase"
                  >
                    Single Invoice
                  </Badge>
                )}
              {orderData?.spocDetails?.estimateApprovalFormUrl && (
                <Link
                  href={orderData.spocDetails?.estimateApprovalFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  _hover={{ textDecoration: "none" }}
                >
                  <Badge
                    backgroundColor={"blue.500"}
                    fontSize={"xx-small"}
                    height={"fit-content"}
                    outline={"none"}
                    color={"white"}
                    mr={2}
                    cursor={"pointer"}
                    _hover={{ backgroundColor: "blue.600" }}
                    transition="background-color 0.2s"
                  >
                    Estimate Approval Form
                  </Badge>
                </Link>
              )}
              {orderStatus === OrderStatus.READY_TO_DISPATCH && (
                <Icon fontSize={"xl"}>
                  <FaTruckLoading />
                </Icon>
              )}

              {orderStatus === OrderStatus.DELIVERED && (
                <GaraazGeneralPopover
                  ArekeysVisible={true}
                  CopierKeys={[]}
                  title="Delivery Info"
                  value={[
                    {
                      "Delivery Date":
                        orderData.deliveryInfo?.deliveryDate ?? "",
                      "Delivery Time":
                        orderData.deliveryInfo?.deliveryTime ?? "",
                      "Delivery Person":
                        orderData.deliveryInfo?.deliveryPerson ?? "",
                      "Delivery Remarks":
                        orderData.deliveryInfo?.deliveryRemarks ?? "",
                    },
                  ]}
                  trigger={"click"}
                >
                  <PopoverTrigger>
                    <Icon cursor={"pointer"} fontSize={"xl"}>
                      <FcShipped />
                    </Icon>
                  </PopoverTrigger>
                </GaraazGeneralPopover>
              )}

              {orderStatus === OrderStatus.DELIVERED && (
                <GaraazGeneralPopover
                  ArekeysVisible={true}
                  CopierKeys={[]}
                  title="Payment Info"
                  value={[
                    {
                      "Hard Cash": orderData.paymentInfo?.hardCash ?? "",
                      "Online Payment Amount":
                        orderData.paymentInfo?.onlinePaymentAmount ?? "",
                      "Cheque Amount":
                        orderData.paymentInfo?.chequeAmount ?? "",
                    },
                  ]}
                  trigger={"click"}
                >
                  <PopoverTrigger>
                    <Icon cursor={"pointer"} fontSize={"xl"} ml={2}>
                      <CurrencyRupeeIcon></CurrencyRupeeIcon>
                    </Icon>
                  </PopoverTrigger>
                </GaraazGeneralPopover>
              )}
            </Box>
          </Box>
          <Box>
            <Text fontWeight={"bold"} color={"#1A202C"}>
              SHIP TO{" "}
              {isCustomerOrderFreezed && (
                <Badge
                  fontSize={"3xs"}
                  colorScheme={
                    orderData.customer.isBlocked === true ? "red" : "orange"
                  }
                  height={"fit-content"}
                >
                  {orderData.customer.isBlocked === true
                    ? "BLOCKED"
                    : OrderTypes.VIRTUAL}
                </Badge>
              )}
            </Text>
            <HStack>
              <GaraazGeneralPopoverV2
                ArekeysVisible={[true, true, false, false, true, true, true]}
                title={orderData?.customer?.name}
                onTitleClick={() =>
                  openMissionControlUrl(
                    getCustomerMissionControlUrl(
                      orderData.customer?.mobileNumber,
                    ),
                  )
                }
                titleSubtitle={
                  <>
                    {!!`${orderData?.customer?.ownerName ?? ""}`.trim() && (
                      <HStack spacing={0} alignItems="center" lineHeight="1.2">
                        <Text fontSize="sm" color="gray.600" minWidth="100px">
                          Owner Name
                        </Text>
                        <Text fontSize="sm" color="gray.600" marginRight="5px">
                          :
                        </Text>
                        <Icon
                          as={FiUser}
                          boxSize="12px"
                          color="gray.600"
                          mr="3px"
                          aria-label="Owner"
                        />
                        <Text fontSize="sm" color="gray.600" noOfLines={1}>
                          {`${orderData.customer.ownerName}`.trim()}
                        </Text>
                      </HStack>
                    )}
                    {orderData?.customer?.mobileNumber && (
                      <HStack spacing={0} alignItems="center" lineHeight="1.2">
                        <Tooltip label="Registered Mobile Number">
                          <Text fontSize="sm" color="gray.600" minWidth="100px">
                            RMN
                          </Text>
                        </Tooltip>
                        <Text fontSize="sm" color="gray.600" marginRight="5px">
                          :
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                          {formatMobileNumber(orderData.customer.mobileNumber)}
                        </Text>
                        <GarrazCopyText
                          text={getNationalMobileForCopy(
                            orderData.customer.mobileNumber,
                          )}
                          popOverMessage="Mobile Number Copied"
                        />
                      </HStack>
                    )}
                  </>
                }
                value={[
                  prepareCreditInfoArray(orderData?.customer),
                  prepareSPOCInfoArray(orderData?.customer),
                  preparePopverAddressObject(orderData?.shipmentAddress),
                  preparePopverAddressObject(
                    orderData?.billingDetails?.address,
                    false,
                  ),
                  prepareBillingInfoArray(),
                  customerSupplierAssociations,
                  prepareSalesmanInfoArray(orderData?.customer),
                ]}
                CopierKeys={[
                  "SPOC Number",
                  "Mobile Number",
                  "Supplier Code",
                  "GST",
                ]}
                titleIcon={
                  <>
                    <GarrazCopyText
                      text={customerDetailsToCopy}
                      popOverMessage="Customer Details Copied"
                    />
                    {orderData?.customer?.mobileNumber && (
                      <Icon
                        as={FaExternalLinkAlt}
                        boxSize="12px"
                        color="blue.500"
                        cursor="pointer"
                        ml={1}
                        aria-label="Open customer in Mission Control"
                        onClick={(e: MouseEvent) => {
                          e.stopPropagation();
                          openMissionControlUrl(
                            getCustomerMissionControlUrl(
                              orderData.customer?.mobileNumber,
                            ),
                          );
                        }}
                      />
                    )}
                  </>
                }
                subTitles={[
                  "Credit Info",
                  "SPOC Info",
                  "Shipment Details",
                  "Billing Details",
                  "",
                  "Associations",
                  "Salesman Info",
                ]}
              >
                <PopoverTrigger>
                  <Text
                    fontWeight={"bold"}
                    textTransform={"uppercase"}
                    color="teal.600"
                    cursor={"pointer"}
                    fontSize={"xs"}
                    display={"flex"}
                    alignItems={"center"}
                    onClick={(e: MouseEvent) => {
                      e.stopPropagation();
                      openMissionControlUrl(
                        getCustomerMissionControlUrl(
                          orderData.customer?.mobileNumber,
                        ),
                      );
                    }}
                  >
                    {orderData.customer?.name}
                    <BiChevronDown
                      style={{ display: "inline", fontSize: "1.5em" }}
                    />
                  </Text>
                </PopoverTrigger>
              </GaraazGeneralPopoverV2>
              {isCustomerChatAllowed &&
                orderData.orderType !== OrderTypes.VIRTUAL && (
                  <Box>
                    <ChatButton
                      chatType={ChatType.CUSTOMER}
                      participantName={orderData.customer?.name}
                      participantId={orderData.customer?._id || ""}
                      orderNo={orderData.orderNo}
                      orderHandlerUserId={
                        orderData.orderHandler?.[0]?._id || ""
                      }
                      isOrderHandler={
                        userDetails?._id === orderData.orderHandler?.[0]?._id
                      }
                      isDisabled={!orderData.customer?._id}
                    />
                  </Box>
                )}
            </HStack>
            <Text fontSize={"3xs"}>{orderData?.customer?.type}</Text>
            <HStack alignItems={"center"} spacing={2}>
              <Text fontSize={"xs"}>{orderData?.customer?.code}</Text>
              <GarrazCopyText
                popOverMessage="Garaaz Code Copied"
                text={orderData?.customer?.code}
              />
            </HStack>
            {renderEngagementModeBadge()}
          </Box>

          <Box
            cursor={
              orderData?.isDeleted ||
              isCustomerOrderFreezed ||
              isEnquiryLocked
                ? "not-allowed"
                : "pointer"
            }
            onClick={() => {
              if (
                orderData?.isDeleted ||
                isCustomerOrderFreezed ||
                isEnquiryLocked
              ) {
                return;
              }
              onOpenCptUpdate?.();
            }}
          >
            <VStack alignItems={"flex-start"} spacing={0}>
              {isPlatformInfiniteEta ? (
                <HStack alignItems="flex-start" spacing={1}>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"column"}
                  >
                    <Text fontWeight={"bold"} color={"#1A202C"}>
                      {isEnquiryOrder
                        ? `${GetOrderLabels.ENQUIRY} ETA`
                        : "CPT"}
                    </Text>
                    <Icon fontSize={"2xl"}>
                      {" "}
                      <BiInfinite></BiInfinite>
                    </Icon>
                  </Box>
                  {!!orderEta?.length && (
                    <Popover trigger="hover" placement="bottom-start">
                      <PopoverTrigger>
                        <IconButton
                          aria-label={
                            isEnquiryOrder ? "ETA history" : "CPT history"
                          }
                          title={
                            isEnquiryOrder ? "ETA history" : "CPT history"
                          }
                          icon={<InfoOutlineIcon boxSize={3} />}
                          size="xs"
                          variant="ghost"
                          minW="16px"
                          h="16px"
                          p={0}
                          mt={1}
                          color="gray.500"
                          _hover={{ color: "gray.700", bg: "transparent" }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </PopoverTrigger>
                      <PopoverContent p="0.7rem">
                        <Text
                          fontSize={"medium"}
                          fontWeight={"bold"}
                          marginBottom={"5px"}
                          textTransform={"uppercase"}
                        >
                          {isEnquiryOrder
                            ? `${GetOrderLabels.ENQUIRY} ETA`
                            : "CPT"}
                        </Text>
                        {orderEta?.map((etaObj: any, index: any) => (
                          <HStack spacing={1} key={index}>
                            <Box alignSelf={"flex-start"}>
                              <Text>{String(index + 1)}.</Text>
                            </Box>
                            <GaraazPopOverContainerStack
                              key={index}
                              etaObj={etaObj}
                              isLast={index === (orderEta?.length ?? 0) - 1}
                            />
                          </HStack>
                        ))}
                      </PopoverContent>
                    </Popover>
                  )}
                </HStack>
              ) : (
                <>
                  <Box display={"flex"} alignItems={"center"}>
                    {(showMissedEta ||
                      finalOrcaStates.includes(orderStatus)) && (
                      <Text fontWeight={"bold"} color={"#1A202C"}>
                        {isEnquiryOrder
                          ? `${GetOrderLabels.ENQUIRY} ETA`
                          : "CPT"}
                      </Text>
                    )}
                  </Box>

                  {!orderEta?.length &&
                    !startOrcaStates.includes(orderStatus) &&
                    !finalOrcaStates.includes(orderStatus) && (
                      <Box display={"flex"}>
                        {!etaProvideMissed && (
                          <GaraazCountDownClockV2
                            componentSize="medium"
                            value0={etaProvideClockValue0}
                            value100={etaProvideClockValue100}
                            titleLabel={
                              isEnquiryOrder
                                ? `${GetOrderLabels.ENQUIRY} P.ETA`
                                : "CPT"
                            }
                            onCompleteTime={onEtaProvideTimeComplete}
                            isCompleted={etaProvideMissed}
                            setIsCompleted={setEtaProvideMissed}
                          ></GaraazCountDownClockV2>
                        )}

                        {etaProvideMissed && (
                          <HStack spacing={1}>
                            <FiAlertTriangle
                              color="red"
                              style={{ marginLeft: "2px" }}
                            />
                            <Text>ETA Missed</Text>
                          </HStack>
                        )}
                      </Box>
                    )}

                  {!!orderEta?.length &&
                    !startOrcaStates.includes(orderStatus) &&
                    !finalOrcaStates.includes(orderStatus) &&
                    !showMissedEta && (
                      <VStack spacing={0} alignItems="center">
                        <HStack spacing="3px" alignItems="center">
                          <GaraazCountDownClockV2
                            value0={latestETAGivenTimeInSeconds}
                            value100={latestETAInSeconds}
                            componentSize="medium"
                            titleLabel={
                              isEnquiryOrder
                                ? `${GetOrderLabels.ENQUIRY} ETA`
                                : "CPT"
                            }
                            onCompleteTime={onEtaTimeComplete}
                            isCompleted={etaMissed}
                            setIsCompleted={setEtaMissed}
                          ></GaraazCountDownClockV2>
                          <Popover trigger="hover" placement="bottom-start">
                            <PopoverTrigger>
                              <IconButton
                                aria-label={
                                  isEnquiryOrder
                                    ? "ETA history"
                                    : "CPT history"
                                }
                                title={
                                  isEnquiryOrder
                                    ? "ETA history"
                                    : "CPT history"
                                }
                                icon={<InfoOutlineIcon boxSize={3} />}
                                size="xs"
                                variant="unstyled"
                                minW="12px"
                                w="12px"
                                h="12px"
                                p={0}
                                display="inline-flex"
                                alignItems="center"
                                justifyContent="center"
                                color="gray.500"
                                _hover={{
                                  color: "gray.700",
                                  bg: "transparent",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </PopoverTrigger>
                            <PopoverContent p="0.7rem">
                              <Text
                                fontSize={"medium"}
                                fontWeight={"bold"}
                                marginBottom={"5px"}
                                textTransform={"uppercase"}
                              >
                                {isEnquiryOrder
                                  ? `${GetOrderLabels.ENQUIRY} ETA`
                                  : "CPT"}
                              </Text>
                              {orderEta?.map((etaObj: any, index: any) => (
                                <HStack spacing={1} key={index}>
                                  <Box alignSelf={"flex-start"}>
                                    <Text>{String(index + 1)}.</Text>
                                  </Box>
                                  <GaraazPopOverContainerStack
                                    key={index}
                                    etaObj={etaObj}
                                    isLast={index === (orderEta?.length ?? 0) - 1}
                                  />
                                </HStack>
                              ))}
                            </PopoverContent>
                          </Popover>
                        </HStack>
                        {cptGaraazSlot ? (
                          <GaraazCptSlotLabel
                            slot={cptGaraazSlot}
                            variant="compact"
                          />
                        ) : null}
                      </VStack>
                    )}

                  {(showMissedEta || finalOrcaStates.includes(orderStatus)) && (
                    <HStack spacing={1} alignItems="center">
                      <Text
                        fontSize={"xs"}
                        color={`${
                          finalOrcaStates.includes(orderStatus)
                            ? "black"
                            : isEstimateRequired
                              ? shouldShowAsMissed
                                ? "red"
                                : "black"
                              : "red"
                        }`}
                      >
                        {orderEta?.length ? formatTime(latestETA) : null}
                      </Text>
                      {!!orderEta?.length && (
                        <Popover trigger="hover" placement="bottom-start">
                          <PopoverTrigger>
                            <IconButton
                              aria-label={
                                isEnquiryOrder
                                  ? "ETA history"
                                  : "CPT history"
                              }
                              title={
                                isEnquiryOrder
                                  ? "ETA history"
                                  : "CPT history"
                              }
                              icon={<InfoOutlineIcon boxSize={3} />}
                              size="xs"
                              variant="ghost"
                              minW="16px"
                              h="16px"
                              p={0}
                              color="gray.500"
                              _hover={{
                                color: "gray.700",
                                bg: "transparent",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </PopoverTrigger>
                          <PopoverContent p="0.7rem">
                            <Text
                              fontSize={"medium"}
                              fontWeight={"bold"}
                              marginBottom={"5px"}
                              textTransform={"uppercase"}
                            >
                              {isEnquiryOrder
                                ? `${GetOrderLabels.ENQUIRY} ETA`
                                : "CPT"}
                            </Text>
                            {orderEta?.map((etaObj: any, index: any) => (
                              <HStack spacing={1} key={index}>
                                <Box alignSelf={"flex-start"}>
                                  <Text>{String(index + 1)}.</Text>
                                </Box>
                                <GaraazPopOverContainerStack
                                  key={index}
                                  etaObj={etaObj}
                                  isLast={index === (orderEta?.length ?? 0) - 1}
                                />
                              </HStack>
                            ))}
                          </PopoverContent>
                        </Popover>
                      )}
                    </HStack>
                  )}
                </>
              )}
            </VStack>
          </Box>
          {!!activesupplierOrderStatus && (
            <Popover trigger="hover">
              <PopoverTrigger>
                <Box cursor={"pointer"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={"small"}
                    color={"#1A202C"}
                    display={"flex"}
                    alignItems={"center"}
                  >
                    SUPPLIER STATUS
                    <BiChevronDown
                      style={{ display: "inline", fontSize: "1.5em" }}
                    />
                  </Text>
                  <HStack>
                    <Text
                      fontWeight={"bold"}
                      textTransform={"uppercase"}
                      color="teal.600"
                      cursor={"pointer"}
                      fontSize={"xs"}
                      display={"flex"}
                      onClick={(e: MouseEvent) => {
                        e.stopPropagation();
                        openMissionControlUrl(
                          getSupplierMissionControlUrl(
                            activesupplierOrderStatus?.supplierId,
                          ),
                        );
                      }}
                    >
                      {activerSupplierName}
                    </Text>
                    {orderData.orderType !== OrderTypes.VIRTUAL && (
                      <Box>
                        <ChatButton
                          chatType={ChatType.SUPPLIER}
                          participantName={activerSupplierName}
                          participantId={
                            activesupplierOrderStatus?.supplierId || ""
                          }
                          orderNo={orderData.orderNo}
                          orderHandlerUserId={
                            orderData.orderHandler?.[0]?._id || ""
                          }
                          isOrderHandler={
                            userDetails?._id ===
                            orderData.orderHandler?.[0]?._id
                          }
                          isDisabled={
                            !(
                              activesupplierOrderStatus &&
                              activesupplierOrderStatus?.isActive
                            )
                          }
                        />
                      </Box>
                    )}
                    {(() => {
                      const actionIcon = activesupplierOrderStatus.actionType
                        ? ALLOCATION_ACTION_ICONS[
                            activesupplierOrderStatus.actionType
                          ]
                        : null;
                      if (!actionIcon) return null;
                      return (
                        <Tooltip
                          label={actionIcon.label}
                          hasArrow
                          placement="top"
                          shouldWrapChildren
                          bg={actionIcon.color}
                          color="white"
                        >
                          <Box
                            as="span"
                            display="inline-flex"
                            alignItems="center"
                            cursor="default"
                            onMouseEnter={(e: MouseEvent) =>
                              e.stopPropagation()
                            }
                          >
                            <Icon
                              as={actionIcon.icon}
                              color={actionIcon.color}
                              boxSize={4}
                            />
                          </Box>
                        </Tooltip>
                      );
                    })()}
                  </HStack>
                  {activesupplierOrderStatus.branchId && (
                    <Text fontSize={"3xs"}>
                      {getSupplierBranchName(
                        activesupplierOrderStatus.supplierId,
                        activesupplierOrderStatus.branchId,
                      )}
                    </Text>
                  )}
                  <Tooltip
                    label={
                      isSupplierStatusEligibleForDashboard(
                        activesupplierOrderStatus.orderStatus,
                      )
                        ? "View this order in supplier dashboard"
                        : "Dashboard opens only for IN REVIEW status"
                    }
                    hasArrow
                    shouldWrapChildren
                  >
                    <Badge
                      backgroundColor={
                        getSupplierStateColor(
                          activesupplierOrderStatus.orderStatus as any,
                        )?.color
                      }
                      color={
                        getSupplierStateColor(
                          activesupplierOrderStatus.orderStatus as any,
                        )?.textColor
                      }
                      fontSize={"xx-small"}
                      cursor={
                        isSupplierStatusEligibleForDashboard(
                          activesupplierOrderStatus.orderStatus,
                        )
                          ? "pointer"
                          : "not-allowed"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (
                          !isSupplierStatusEligibleForDashboard(
                            activesupplierOrderStatus.orderStatus,
                          )
                        ) {
                          return;
                        }
                        openSupplierDashboardForOrder(
                          activesupplierOrderStatus?.supplierId,
                        );
                      }}
                    >
                      {removeUnderScoreWithUpperCase(
                        activesupplierOrderStatus.orderStatus,
                      )}
                    </Badge>
                  </Tooltip>
                </Box>
              </PopoverTrigger>
              <PopoverContent padding={3}>
                <OrderedList>
                  {orderData.allocatedTo.map((item: any, index: number) => {
                    const displayStatus =
                      item.actionType === "STOCK_OUT" &&
                      item.orderStatus === "READY"
                        ? "TRANSFERRED"
                        : removeUnderScoreWithUpperCase(item.orderStatus);
                    return (
                      <ListItem key={index}>
                        <Box _notFirst={{ marginTop: "4" }}>
                          <Box
                            color={"#1A202C"}
                            display={"flex"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Text
                              fontSize={"smaller"}
                              cursor="pointer"
                              onClick={(e: MouseEvent) => {
                                e.stopPropagation();
                                openMissionControlUrl(
                                  getSupplierMissionControlUrl(item.supplierId),
                                );
                              }}
                            >
                              {" "}
                              {getSupplierBusinessName(item.supplierId)}
                            </Text>
                            {item.supplierId && (
                              <Icon
                                as={FaExternalLinkAlt}
                                boxSize="11px"
                                color="blue.500"
                                cursor="pointer"
                                aria-label="Open supplier in Mission Control"
                                onClick={(e: MouseEvent) => {
                                  e.stopPropagation();
                                  openMissionControlUrl(
                                    getSupplierMissionControlUrl(
                                      item.supplierId,
                                    ),
                                  );
                                }}
                              />
                            )}
                          </Box>
                          {item.branchId && (
                            <Box>
                              <Text fontSize={"2xs"}>
                                {getSupplierBranchName(
                                  item.supplierId,
                                  item.branchId,
                                )}
                              </Text>
                            </Box>
                          )}
                          <Text
                            fontSize={"smaller"}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            {formatSupplierNumber(
                              item.supplierId,
                              item?.branchId,
                            )}
                            <GarrazCopyText
                              popOverMessage="Supplier number Copied"
                              text={getNationalMobileForCopy(
                                getSupplierNumber(
                                  item.supplierId,
                                  item?.branchId,
                                ),
                              )}
                            />
                          </Text>
                          <Tooltip
                            label={
                              isSupplierStatusEligibleForDashboard(
                                item.orderStatus,
                              )
                                ? "View this order in supplier dashboard"
                                : "Dashboard opens only for IN REVIEW status"
                            }
                            hasArrow
                            shouldWrapChildren
                          >
                            <Badge
                              backgroundColor={
                                getSupplierStateColor(item.orderStatus as any)
                                  ?.color
                              }
                              color={
                                getSupplierStateColor(item.orderStatus as any)
                                  ?.textColor
                              }
                              fontSize={"xx-small"}
                              cursor={
                                isSupplierStatusEligibleForDashboard(
                                  item.orderStatus,
                                )
                                  ? "pointer"
                                  : "not-allowed"
                              }
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (
                                  !isSupplierStatusEligibleForDashboard(
                                    item.orderStatus,
                                  )
                                ) {
                                  return;
                                }
                                openSupplierDashboardForOrder(item.supplierId);
                              }}
                            >
                              {displayStatus}
                            </Badge>
                          </Tooltip>
                          {item.actionType === "STOCK_OUT" &&
                            item.orderStatus === "READY" && (
                              <>
                                <Text
                                  fontSize={"xs"}
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={2}
                                >
                                  {item.stockTransferInfo?.stockTransferNo}
                                  <Text
                                    fontSize={"xs"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    cursor={"pointer"}
                                    onClick={() => {
                                      downloadInvoiceForOrder(
                                        item.stockTransferInfo
                                          ?.stockTransferMediaId,
                                      );
                                    }}
                                    color="teal.600"
                                    _hover={{ color: "teal.700" }}
                                  >
                                    <BiDownload size={16} />
                                  </Text>
                                  <GarrazCopyText
                                    popOverMessage="Stock Transfer No Copied"
                                    text={
                                      item.stockTransferInfo?.stockTransferNo
                                    }
                                  />
                                </Text>
                                <Text
                                  fontSize={"xs"}
                                  display={"flex"}
                                  alignItems={"center"}
                                >
                                  {formatDateTime(item.stateTime)}
                                </Text>
                              </>
                            )}
                        </Box>
                      </ListItem>
                    );
                  })}
                </OrderedList>
              </PopoverContent>
            </Popover>
          )}
        </HStack>
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-start"}
          height="auto"
          width={"36%"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignContent={"flex-end"}
            flexDir={"column"}
            marginLeft={"auto"}
            gap={1}
            alignItems={"flex-end"}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"flex-end"}
              textAlign={"end"}
              marginLeft={"auto"}
            >
              {orderData.isDeleted && (
                <Tooltip
                  label={
                    <VStack align="start" spacing={0} p={1} maxW="300px">
                      <Text fontWeight="bold" fontSize="xs">
                        Voided by: {orderData.deletedByUserName || "Unknown"}
                      </Text>
                      {orderData.deletionReason && (
                        <Text
                          fontWeight="bold"
                          fontSize="xs"
                          wordBreak="break-word"
                        >
                          Reason: {orderData.deletionReason}
                        </Text>
                      )}
                    </VStack>
                  }
                  hasArrow
                  placement="top"
                >
                  <Badge
                    display="inline-flex"
                    alignItems="center"
                    bg="#FFF5F5"
                    border="1px solid"
                    borderColor="#FEB2B2"
                    borderRadius="md"
                    color="#C53030"
                    fontSize="xs"
                    fontWeight="bold"
                    px={1}
                    py={0.5}
                    mr={2}
                    lineHeight="1"
                    textTransform="uppercase"
                    cursor="help"
                  >
                    VOIDED
                  </Badge>
                </Tooltip>
              )}
              {orderData.orderType === "REGULAR" && (
                <Icon mr={1} fontSize={"xl"} fontWeight={"bold"}>
                  <BiCart></BiCart>
                </Icon>
              )}
              {orderData.orderType === "RETURN" && (
                <Icon mt={1}>
                  <GiReturnArrow />
                </Icon>
              )}
              {orderData.orderType === "SUBSCRIPTION" && (
                <Icon mr={1} fontSize={"xl"}>
                  <BiDollarCircle></BiDollarCircle>
                </Icon>
              )}
              <Text> {`${orderLabel.toUpperCase()} #`} </Text>

              <Text
                fontSize={"12px"}
                marginLeft={"3px"}
                textAlign={"end"}
                color={"#1A202C"}
              >
                {orderData.orderType === "RETURN" ? "RT-" : ""}
                {orderNotoShow}
              </Text>

              <GarrazCopyText
                popOverMessage={`${orderLabel} No Copied`}
                text={orderData.orderNo}
              />
            </Box>
            {isEnquiryOrder && (
              <>
                <Tooltip
                  label="% Enquiries Cancelled | Total Enquiries"
                  bg="gray.700"
                  color="white"
                  fontSize="sm"
                  borderRadius="md"
                  placement="auto"
                  hasArrow
                >
                  <Text color="gray.600" cursor="pointer">
                    {(() => {
                      const total =
                        orderData?.customer?.metaInfo?.totalEnquiries ?? 0;
                      const cancelled =
                        orderData?.customer?.metaInfo
                          ?.totalEnquiriesCancelled ?? 0;
                      if (total === 0) {
                        return "0% cancelled of 0 enquiries";
                      }
                      const percentage = ((cancelled / total) * 100).toFixed(1);
                      return `${percentage}% | ${total}`;
                    })()}
                  </Text>
                </Tooltip>
              </>
            )}
            {!isEnquiryOrder &&
              orderData.orderType !== OrderTypes.VIRTUAL &&
              deliveryStatusLabel && (
                <HStack spacing={1}>
                  {deliveryStatusLabel && (
                    <Text
                      as="span"
                      display="inline-flex"
                      alignItems="center"
                      gap={1}
                      bg="#F5F8FF"
                      border="1px solid"
                      borderColor="#C9D4E5"
                      color="#2B5CA6"
                      borderRadius="md"
                      fontSize="xx-small"
                      fontWeight="bold"
                      fontFamily="inherit"
                      textTransform="uppercase"
                      letterSpacing="0.15px"
                      h="22px"
                      px={2.5}
                      cursor="default"
                      lineHeight="22px"
                      whiteSpace="nowrap"
                    >
                      {deliveryStatusLabel}
                      {hasDeliveryCost
                        ? ` : ${formatCurrency(deliveryCostValue)}`
                        : ""}
                    </Text>
                  )}
                </HStack>
              )}
          </Box>

          <Box
            display={"flex"}
            flexDirection={"column"}
            width={"100%"}
            marginTop="0.35rem"
            alignItems={"flex-end"}
          >
            {showPaymentRoute && (
              <Box my={1}>
                <PaymentRouteBadge
                  orderId={orderData?._id}
                  payableBy={orderData?.payableBy}
                  payableTo={orderData?.payableTo}
                  orderStatus={orderData?.orderStatus}
                  onUpdated={refetchAllOrders}
                  allowEdit={paymentRouteEditable}
                  billingEntity={orderData?.billingDetails?.billingEntity}
                />
              </Box>
            )}
            <Box
              display={"flex"}
              justifyContent={"flex-end"}
              alignItems={"flex-end"}
            >
              <Badge
                background={
                  orderData?.customer?.paymentRelationType ===
                  PaymentType.POSTPAID
                    ? "#4776e6"
                    : "#8e54e9"
                }
                color={"white"}
                fontSize={"xx-small"}
                ml={2}
                display={"flex"}
                alignItems={"center"}
              >
                {orderData?.customer?.paymentRelationType ===
                PaymentType.POSTPAID
                  ? "POSTPAID"
                  : "PREPAID"}
              </Badge>
              {(activesupplierOrderStatus?.supplierId ===
                "62bbfb934de9282bc818d3a1" ||
                getSupplierParentId(activesupplierOrderStatus?.supplierId) ===
                  "62bbfb934de9282bc818d3a1") && (
                <Badge
                  fontSize={"xx-small"}
                  height={"fit-content"}
                  outline={"0.1px solid grey"}
                  ml={2}
                >
                  <Popover>
                    {({ isOpen, onClose }) => (
                      <>
                        <PopoverTrigger>
                          <Text fontSize={"xx-small"} cursor={"pointer"}>
                            Meta Info
                          </Text>
                        </PopoverTrigger>
                        <PopoverContent maxWidth={"30em"}>
                          <PopoverHeader>
                            <Text>IAM Customer Type & Discount</Text>
                          </PopoverHeader>
                          <PopoverBody>
                            <VStack alignItems={"flex-end"}>
                              <label style={{ marginRight: "auto" }}>
                                Select customer Type
                              </label>
                              <Select
                                name="customerType"
                                placeholder={`Select customer Type`}
                                onChange={(e) =>
                                  setCustomerType(e.target.value)
                                }
                                value={customerType ?? ""}
                                cursor={"pointer"}
                                size={"sm"}
                              >
                                <option value="Cash">Cash</option>
                                <option value="Credit">Credit</option>
                              </Select>
                              <label style={{ marginRight: "auto" }}>
                                Enter Customer Discount
                              </label>
                              <NumberInput
                                width={"100%"}
                                value={customerDiscount}
                                onChange={(e) => {
                                  const value = Number(e);
                                  if (value >= 0 && value <= 100) {
                                    setCustomerDiscount(e);
                                  } else {
                                    toast({
                                      description:
                                        "Discount must be between 0 and 100",
                                      status: "warning",
                                    });
                                  }
                                }}
                                size={"sm"}
                              >
                                <NumberInputField placeholder="Enter Customer Discount" />
                              </NumberInput>
                              <Button
                                colorScheme="blue"
                                size={"xs"}
                                onClick={() => {
                                  handleMetaInfoChange();
                                  onClose();
                                }}
                              >
                                Confirm
                              </Button>
                            </VStack>
                          </PopoverBody>
                        </PopoverContent>
                      </>
                    )}
                  </Popover>
                </Badge>
              )}

              {transactionType && (
                <Badge
                  backgroundColor={"white"}
                  fontSize={"xx-small"}
                  outline={"1px solid green"}
                  ml={2}
                >
                  {transactionType === "Facilitation" ? "F" : "T"}
                </Badge>
              )}

              {orderData.orderType === "REGULAR" && (
                <>
                  <Badge
                    fontSize="xx-small"
                    height="fit-content"
                    outline="0.1px solid grey"
                    ml={2}
                  >
                    <Popover placement="bottom">
                      {({ isOpen, onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Text fontSize="xx-small" cursor="pointer">
                              VT
                            </Text>
                          </PopoverTrigger>

                          <PopoverContent maxWidth="90vw">
                            <PopoverHeader>
                              <Text fontWeight="medium">Vehicle Type</Text>
                            </PopoverHeader>
                            <PopoverBody>
                              <VStack alignItems="flex-end" spacing={3}>
                                <NumberInput
                                  width="100%"
                                  size="sm"
                                  id={`ppd-amount-${orderData.orderNo}`}
                                  value={vehicleType}
                                  onChange={(e: any) => {
                                    if (Number(e) >= 0)
                                      setVehicleType(Number(e));
                                  }}
                                >
                                  <NumberInputField placeholder="Enter Vehicle Type" />
                                </NumberInput>

                                <Button
                                  size="xs"
                                  colorScheme="blue"
                                  onClick={() => {
                                    handleVehicleTypeSubmit();
                                    onClose();
                                  }}
                                  isDisabled={
                                    vehicleType === "" || vehicleType == 0
                                  }
                                >
                                  Confirm
                                </Button>
                              </VStack>
                            </PopoverBody>
                          </PopoverContent>
                        </>
                      )}
                    </Popover>
                  </Badge>
                  {isFreeDelivery ? (
                    <Badge
                      fontSize="xx-small"
                      height="fit-content"
                      outline="0.1px solid grey"
                      ml={2}
                    >
                      FREE
                    </Badge>
                  ) : (
                    <></>
                  )}
                </>
              )}
              {(orderData?.isVehicleInfoExtractedByOpenAI ||
                orderData?.isOrderItemsExtractedByOpenAI) && (
                <Badge
                  background={"linear-gradient(to right, #4776e6, #8e54e9)"}
                  color={"white"}
                  fontSize={"xx-small"}
                  ml={2}
                  display={"flex"}
                  alignItems={"center"}
                >
                  PHANTOM
                </Badge>
              )}
              <Link
                as={NavLink}
                to={paths.cars}
                state={{
                  orderId: orderData._id,
                  orderNo: orderData.orderNo,
                  scrollPosition:
                    window.scrollY || document.documentElement.scrollTop,
                }}
                ml={2}
                display={"flex"}
                alignItems={"center"}
                onClick={() => {
                  setScrollOrderId(orderData._id);
                }}
              >
                <Icon as={FaCarSide}></Icon>
              </Link>
              <Button
                display={"flex"}
                alignItems={"center"}
                mb={0.1}
                onClick={handleOnclickCatalog}
                _hover={{ opacity: 0.8 }}
                _focus={{ bg: "none" }}
                cursor={"pointer"}
                p={0}
                size={"sm"}
                height={"fit-content"}
                width={"fit-content"}
                disabled={
                  !(
                    orderData?.requireEstimate &&
                    orderData._id === orderData.rootOrderId
                  ) || isEnquiryLocked
                }
              >
                <Icon as={MenuBook} fontSize={18}></Icon>
              </Button>
              {orderStatus === OrderStatus.CUSTOMER_HOLD && (
                <Icon as={AiOutlineStop} ml={2} color={"red"}></Icon>
              )}
            </Box>
          </Box>
        </Box>
      </HStack>

      <ChooseCarModel
        isVisible={isCarModalVisible}
        onClose={closeCarModal}
        onConfirm={handleVehicleSearchConfirm}
        selectedValues={vehicleSearchValues}
        onValueChange={handleVehicleSearchValueChange}
        onError={handleVehicleSearchError}
        errorMessage={errorMessage}
        showCancelButton={false}
        confirmButtonText="View OEM Catalogue"
        slideUpPanelTitle="Select Vehicle"
        isConfirmButtonDisabled={!isVehicleSearchValuesValid}
        onLpnSearch={handleLpnSearch}
      />
    </>
  );
};

export default GaraazOrderComponentHeader;
